module.exports = __webpack_public_path__ + "static/media/indicatorAntennaCabel.bde2f6ae.png";